// extracted by mini-css-extract-plugin
export default {"wrapper":"EquipmentStatistics_wrapper__v1pj-"};